import React from 'react';

import { Flex } from '@chakra-ui/react';

import { TextHeader2 } from 'uiToolkitV1/Typography';

import { HeaderMarginContainer } from '../HeaderComponents/HeaderMarginContainer';

interface Props {
  title: string;
}

const Header = ({ title }: Props) => (
  <HeaderMarginContainer>
    <Flex mb="8px" alignItems="center" position="relative" zIndex="10">
      <TextHeader2 mr="8px" bold>
        {title}
      </TextHeader2>
    </Flex>
  </HeaderMarginContainer>
);

export { Header };
